// #303 (UC-2): Zahlen der Vorlagen-Kennzahlen in lesbare Form. PUR, ohne React testbar.

/**
 * Sekunden → Dauer in der Einheit, die der Grössenordnung entspricht.
 *
 * Bewusst nur EINE Nachkomma-Ebene (h+min, d+h): „3h 20min" beantwortet die Frage „wie
 * lange läuft so ein Vorgang", „3h 20min 14s" beantwortet keine.
 */
export function formatDauer(sek: number | null | undefined): string {
  if (sek === null || sek === undefined || !Number.isFinite(sek) || sek < 0) return "—";
  const s = Math.round(sek);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}min`;
  const h = Math.floor(m / 60);
  const restMin = m % 60;
  if (h < 48) return restMin === 0 ? `${h}h` : `${h}h ${restMin}min`;
  const d = Math.floor(h / 24);
  const restStd = h % 24;
  return restStd === 0 ? `${d}d` : `${d}d ${restStd}h`;
}

/**
 * Anteil (0..1) → Prozent.
 *
 * Eine Nachkommastelle nur, wenn sie etwas sagt: „12 %" liest sich besser als „12.0 %",
 * aber „0.5 %" darf nicht zu „0 %" werden (das wäre die Aussage „nie", und die ist falsch).
 */
export function formatQuote(anteil: number | null | undefined): string {
  if (anteil === null || anteil === undefined || !Number.isFinite(anteil)) return "—";
  const p = anteil * 100;
  if (p === 0) return "0 %";
  const gerundet = Math.round(p * 10) / 10;
  return `${Number.isInteger(gerundet) ? gerundet.toFixed(0) : gerundet.toFixed(1)} %`;
}

/**
 * Der Satz, der den Nenner benennt — oder `null`, wenn es nichts zu benennen gibt.
 *
 * ⚠ Das ist keine Kosmetik: `laeufe` ist die exakte Gesamtzahl, aber Zustands-Verteilung
 * und Fehlerquote beschreiben nur die jüngste Stichprobe. Ohne diesen Hinweis läse jemand
 * „5000 von 12000 Läufen" als „12000 Läufe, davon 3 % fehlerhaft" — und die 3 % gälten in
 * Wahrheit für 5000.
 */
export function stichprobenHinweis(stats: {
  laeufe: number;
  ausgewertet: number;
  gekuerzt: boolean;
}): string | null {
  if (!stats.gekuerzt) return null;
  return `Zustände und Fehlerquote beziehen sich auf die ${stats.ausgewertet} jüngsten von ${stats.laeufe} Läufen.`;
}
